import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  surface: {
    inlineSize: "clamp(640px, 80vw, 960px)",
  },
  content: {
    ...shorthands.padding(designTokens.spacing[4]),
    minBlockSize: "20rem",
    maxBlockSize: "calc(90svh - 160px)",
    overflowY: "auto",
  },
  richText: {
    lineHeight: 1.5,
    "& p": { marginBlock: designTokens.spacing[2] },
    "& ul, & ol": { marginInlineStart: designTokens.spacing[5] },
    "& code, & pre": {
      backgroundColor: tokens.colorNeutralBackground3,
      ...shorthands.borderRadius(designTokens.borderRadius.sm),
      ...shorthands.padding("2px", designTokens.spacing[1]),
    },
    "& a": {
      color: "var(--colorBrandForegroundLink)",
      textDecoration: "none",
      ":hover": { textDecoration: "underline" },
    },
    wordBreak: "break-word",
  },
});
